import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizeKey',
  standalone: true
})
export class NormalizeKeyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value
      .toUpperCase()
      .replace(/[-\s]/g, '_')   // Replace hyphens/spaces with underscores
      .replace(/_+/g, '_')      // Collapse multiple underscores
      .trim();
  }
}